import React, { FunctionComponent } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { QueryLoaderWrapper } from '@companion-professional/components';
import { Permissions } from '@companion-professional/dctypes';
import { AppLayout } from './components/AppLayout';
import {
  Dashboard,
  PageNotFound,
  PetParents,
  Pets,
  Settings,
  Profile,
  Checkup,
  GenerateError,
  GroundTruth
} from './pages';
import { Reviews } from './pages/Reviews';
import { PermissionProtectedRoutes } from './components/PermissionProtectedRoutes';
import { useCurrentClinic } from './hooks/useCurrentClinic';
import { useResetSwitchClinicId, useSwitchClinicId } from './state/auth';
import { SwitchClinicDialog } from './components/SwitchClinicDialog';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

// These are all the routes that are available to a logged-in user.
export const LoggedInRoutes: FunctionComponent = () => {
  const location = useLocation();
  const switchClinicId = useSwitchClinicId();
  const resetSwitchClinicId = useResetSwitchClinicId();
  const { clinic, isPending, error } = useCurrentClinic();

  return (
    <AppLayout currentClinic={clinic}>
      <SwitchClinicDialog
        switchToClinicId={switchClinicId}
        returnUrl={location.pathname + location.search}
        open={switchClinicId.length > 0}
        onOpenChange={(open) => {
          if (!open) {
            // If the dialog is closed, then we want to clear the switch clinic id.
            resetSwitchClinicId();
          }
        }}
      />
      <QueryLoaderWrapper isPending={isPending} error={error}>
        <SentryRoutes>
          <Route index element={<Dashboard />} />
          <Route path="/pet-parents/*" element={<PetParents />} />
          <Route path="/pets/*" element={<Pets />} />
          <Route path="/checkup/:checkupId" element={<Checkup />} />
          <Route path="/ground_truth/:checkupId" element={<GroundTruth />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/generate-error" element={<GenerateError />} />
          <Route element={<PermissionProtectedRoutes allowPermissions={[Permissions.checkup_review]} redirectPath="/" />}>
            <Route path="/reviews/*" element={<Reviews />} />
          </Route>
          <Route path="*" element={<PageNotFound />} />
        </SentryRoutes>
      </QueryLoaderWrapper>
    </AppLayout>
  );
};
